import React, { useState, useEffect } from 'react';
import { Box, Container, makeStyles, Paper, Button } from '@material-ui/core';
import Page from 'src/components/Page';
import { useSelector, useDispatch } from 'react-redux';
import TopupFilter from './TopupFilter';
import { getTopup } from 'src/store/actions/TopupActions';
import TopupDataTable from './TopupDataTable';
import SystemTopup from './SystemTopup';
import BankTopup from './BankTopup';
import { convertDateToUnix, getLastNDays } from 'src/utils/utils';
import { baseUrl, stagingUrl } from 'src/api';

const tableHead = [
  { title: 'ID' },
  { title: 'Client' },
  { title: 'Transaction ID' },
  { title: 'Amount' },
  { title: 'Payment Method' },
  { title: 'Narration' },
  { title: 'Status' },
  { title: 'Date' }
];

const tableBody = [];
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  paperTable: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    textAlign: 'right'
  },
  searchBar: {
    // width: '50%',
    display: 'flex',
    justifyContent: 'flex-start',
    // marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1)
  }
}));

const Topup = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [openBankTopup, setOpenBankTopup] = useState(false);
  const topupData = useSelector((state) => state.Topup.topupData);
  const profile = JSON.parse(sessionStorage.getItem('profile'));

  useEffect(() => {
    async function callGetTopup() {
      setLoading(true);
      const filterObj = {
        fromDate: convertDateToUnix(getLastNDays(30)),
        toDate: convertDateToUnix(getLastNDays(0))
      };
      const response = await dispatch(getTopup(filterObj));
      if (response) {
        setLoading(false);
      }
    }
    callGetTopup();
  }, []);

  const handleOpenSystemTopupModal = () => {
    setOpen(true);
  };

  const handleCloseSystemTopupModal = () => {
    setOpen(false);
  };

  const handleOpenBankTopupModal = () => {
    setOpenBankTopup(true);
  };

  const handleCloseBankTopupModal = () => {
    setOpenBankTopup(false);
  };

  const indexedTableData =
    topupData &&
    topupData.map((item, index) => {
      return { ...item, index: index + 1 };
    });

  const bankTopup = baseUrl !== stagingUrl && (
    <Button
      variant="contained"
      color="primary"
      onClick={handleOpenBankTopupModal}
    >
      Bank Topup
    </Button>
  );

  return (
    <Page className={classes.root} title="Topup">
      <SystemTopup open={open} handleClose={handleCloseSystemTopupModal} />
      <BankTopup open={openBankTopup} handleClose={handleCloseBankTopupModal} />
      <Container maxWidth={false}>
        <Box>
          <TopupFilter />
        </Box>

        <Paper className={classes.paperTable}>
          <Box>
            {profile?.super == 1 ? (
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: 10 }}
                onClick={handleOpenSystemTopupModal}
              >
                System Topup
              </Button>
            ) : (
              bankTopup
            )}
          </Box>
          <Box mt={3}>
            <TopupDataTable
              className={classes}
              tableHead={tableHead}
              tableData={indexedTableData}
              loading={loading}
            />
          </Box>
        </Paper>
      </Container>
    </Page>
  );
};

export default Topup;
